<template>
  <search-group title="" @search="findData" @clear="clearValue"
                :multipleLines="true" :inline="false" :span="24" :btnOffset="18" :btnSpan="6"

  >
    <Row class="mb16" :gutter="16">
      <Col span="6">
        <Select v-model="searchData.cityCode" placeholder="选择城市" @on-change="searchData.projectFid=''">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in cityList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <Select v-model="searchData.projectFid" placeholder="请选择项目">
                    <Option value=''>请选择</Option>
                    <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB2'+index">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.businessFromChannel" placeholder="来源渠道" >
          <Option value="">请选择</Option>
          <Option
            value="100" v-for="item in conditions?conditions.channel:[]" :value="item.value" :key="item.value+'keyG'">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.isLook" placeholder="是否带看"      >
          <Option value="">请选择</Option>
          <Option v-for="item in conditions?conditions.isLook:[]" :value="item.value" :key="item.value+'keyH'">{{item.text}}</Option>
        </Select>
      </Col>

      <Col span="4">
        <Select v-model="searchData.handleStatus" placeholder="商机状态" >
          <Option value="">请选择</Option>

          <Option value="100" v-for="item in conditions?conditions.status:[]" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
    <Row class="mb16" :gutter="16">

      <Col span="8">
        <DatePicker class="block" type="datetimerange" split-panels placeholder="商机创建时间" v-model="createDate" format="yyyy-MM-dd HH:mm" ></DatePicker>

      </Col>
      <Col span="8">
        <DatePicker class="block" type="datetimerange" split-panels placeholder="截止处理时间" v-model="needDate" format="yyyy-MM-dd HH:mm" ></DatePicker>
      </Col>
      <Col span="8">
        <Select v-model="searchData.businessType" placeholder="商机类型" >
          <Option value="">请选择</Option>

          <Option value="100" v-for="item in enumList?enumList.businessType:[]" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
    <Row :gutter="16" class="max64">
      <Col span="8" >
        <Input placeholder="跟进人、企业名称、企业联系人、联系电话" v-model="searchData.keywordStr" @keyup.enter.native="findData"></Input>
      </Col>
      <Col span="4" >
        <Select v-model="searchData.gradeList" @on-change="checkGradeAll" placeholder="商机等级" multiple>
          <Option value="all">全部选择</Option>
          <Option v-for="item in conditions?conditions.grade:[]" :value="item.text" :key="item.text">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
  </search-group>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime,formatDateTimeExceptSecond} from "../../../../utils/format";
  import {allCityProjects} from "../../../../api/common";

  export default {
    components: {
      SearchGroup
    },
    props: {
      enumList:{
        type:Object,
        default:null
      },
      conditions:{
        type:Object,
        default:null
      }
    },
    created(){
      allCityProjects().then(res=>{
        if(!res.data){
          return
        }
        this.cityList=res.data

      }).catch(error=>{

      })

    },
    mounted() {
      this.$emit('searchData', this.searchDataComputed);
    },
    computed: {
      projectList(){
        if(!this.searchData.cityCode){
          return []
        }
        for(let i=0,len=this.cityList.length;i<len;i++){
          if(this.cityList[i].value===this.searchData.cityCode){
            return this.cityList[i].children||[]
            break;
          }
        }

      },
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTimeExceptSecond(data) : ''
        }

        return {
          "backlogTimeF": f(this.needDate[0]),
          "backlogTimeT": f(this.needDate[1]),
          "createTimeFrom": f(this.createDate[0]),
          "createTimeTo": f(this.createDate[1]),
          ...this.searchData
        }
      }


    },
    data() {
      return {
        cityList:[],
        createDate:['',''],
        needDate:['',''],
        searchData: {
          "businessFromChannel": null,
          "cityCode": null,
          "handleStatus": null,
          "isLook": null,
          "keywordStr": '',
          "projectFid": '',
          businessType:'',
          gradeList: []
        },
        selectedGradeAll: false
      }
    },
    methods: {
      findData() {
        this.$emit('searchData', this.searchDataComputed);
      },
      clearValue() {
        this.searchData = {
          "businessFromChannel": null,
          "cityCode": null,
          "handleStatus": null,
          "isLook": null,
          "keywordStr": '',
          "projectFid": '',
          gradeList: []
        }
        this.createDate=['','']
        this.needDate=['',''],
        this.selectedGradeAll = false
      },
      checkGradeAll () {
        let isCheck = false;
        for (const property in this.searchData.gradeList){
          if(this.searchData.gradeList[property] === 'all'){
            isCheck = true
            this.selectedGradeAll = !this.selectedGradeAll
          }
        }
        if(isCheck && this.selectedGradeAll){
          const values = [];
          for (const property in this.conditions.grade){
            values.push(this.conditions.grade[property].text);
          }
          this.searchData.gradeList = values
        }
        if(isCheck && !this.selectedGradeAll){
          this.searchData.gradeList = []
        }
      }
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
  .block{
    display: block;
  }
</style>
